import styled from 'styled-components';


const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  @media (min-width: 768px) {
    max-width: 750px;
  }
  @media (min-width: 992px) {
    max-width: 970px;
  }
  @media (min-width: 1260px) {
    max-width:980px;
  }
`;
const SubTitle = styled.h1`
  padding-top: 60px;
  padding-bottom: ${({ bottom = 30 }) => `${bottom}px`};
  margin-bottom: 0;
  line-height: 43px;
  font-size: 34px;
  font-weight: 600;
  color: #212833 !important;
  font-family: ${({ theme }) => theme.fontIBMSemiBold};
`;

const Details = styled.p`
    ${({ hasMarginTop }) => (hasMarginTop ? 'margin-top:30px;' : null)};
    ${({ hasFontWeight }) => (hasFontWeight ? 'font-weight: bold;' : null)};
    ${({ hasColor }) => (hasColor ? 'color: #212833;' : 'color: #48515d;')};
    font-family: ${({ hasFontFamily, theme }) => (hasFontFamily ? theme.fontIBMMedium : theme.fontIBMRegular)};
    ${({ hasMarginBottom }) => (hasMarginBottom ? 'margin-bottom: 200px;' : 'margin-bottom: 24px;')};
    font-size:14px;
    line-height:24px;
    & a{
      color:#F0B90B;
    }
    & a:hover{text-decoration: underline;}
    & span{
      font-weight: bold;
      font-size: 14px;
      font-family: ${({ theme }) => theme.fontIBMRegular};
      color: #212833;
    }
`;


const SubtitleTow = styled.h1`
    ${({ hasFontSize }) => (hasFontSize ? 'font-size:16px;' : 'font-size:14px;')}
    font-weight: bold;
    color: #212833 !important;
    font-family: ${({ theme }) => theme.fontIBMMedium};
    line-height:24px;
    margin-bottom: 24px;
`;
const Eggshell = styled.div`
    color: #48515d;
    font-size: 14px;
    font-family: ${({ theme }) => theme.fontIBMRegular};
    line-height: 24px;
    margin-bottom: 24px;
    & ol>li{
        list-style: lower-roman;
        font-size: 14px;
        line-height: 24px;
        margin-bottom: 10px;
        &.cornerMarginTop{
          margin-top:10px;
        }
      }
    & ul>li{
      list-style: disc;
      font-size: 14px;
      line-height: 24px;
      margin-left:40px;
      margin-bottom: 10px;
      &.cornerMarginTop{
        margin-top:10px;
      }
    }
`;

export {
  Container,
  SubTitle,
  Details,
  SubtitleTow,
  Eggshell,
};
